import styled from 'styled-components'

export const LockedLabel = styled.div`
  width: fit-content;
  height: 40px;
  border-radius: 24px;
  padding: 0px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  // background: #CFABF2;
  // background: linear-gradient(90deg,rgba(207, 171, 242, .18) 0%, rgba(108, 92, 231, .18) 31%, rgba(66, 178, 252, .18) 100%);
  background-color: #FEF3C6;
  color: #93410F;
  font-size: 16px;
  font-weight: 600;
  gap: 8px;
`